export const ProjectData = [

  {
    show: true,
    id: '1',
    project: "Project 1",
    github: "https://github.com/pranitcode/Project-1-UI",
    demo: "https://project-1-ui.netlify.app/",
    Image: require("../../img/proj1.png").default
  },
  {
    show: false,
    id: '2',
    project: "Project 2",
    github: "https://github.com/pranitcode/Project-2-UI",
    demo: "https://project-2-ui.netlify.app/",
    Image: require("../../img/proj2.png").default
  },
  {
    show: false,
    id: '3',
    project: "Project 3",
    github: "https://github.com/pranitcode/Project-3-UI",
    demo: "https://project-3-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj3.png").default
  },
  {
    show: false,
    id: '4',
    project: "Project 4",
    github: "https://github.com/pranitcode/Project-4-UI",
    demo: "https://project-4-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj4.png").default
  },
  {
    show: false,
    id: '5',
    project: "Project 5",
    github: "https://github.com/pranitcode/Project-5-UI",
    demo: "https://project-5-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj5.png").default
  },
  {
    show: false,
    id: '6',
    project: "Project 6",
    github: "https://github.com/pranitcode/Project-6-UI",
    demo: "https://project-6-ui.netlify.app/",
    Image: require("../../img/proj6.png").default    
  },
  {
    show: false,
    id: '7',
    project: "Project 7",
    github: "https://github.com/pranitcode/Project-7-UI",
    demo: "https://project-7-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj7.png").default    
  },
  {
    show: false,
    id: '8',
    project: "Project 8",
    github: "https://github.com/pranitcode/Project-8-UI",
    demo: "https://project-8-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj8.png").default
  },

  {
    show: false,
    id: '9',
    project: "Project 9",
    github: "https://github.com/pranitcode/Project-9-UI",
    demo: "https://project-9-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj9.png").default
  },


  {
    show: false,
    id: '10',
    project: "Project 10",
    github: "https://github.com/pranitcode/Project-10-UI",
    demo: "https://project-10-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj10.png").default
  },

  {
    show: true,
    id: '11',
    project:"Project 11",
    github: "https://github.com/pranitcode/Project-11-UI",
    demo: "https://project-11-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj11.png").default
    


  },
  {
    show: false,
    id: '12',
    project: "Project 12",
    github: "https://github.com/pranitcode/Project-12-UI",
    demo: "https://project-12-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj12.png").default
    
    


  },
  {
    show: true,
    id: '13',
    project: "Project 13",
    github: "https://github.com/pranitcode/Project-13-UI",
    demo: "https://project-13-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj13.png").default
    
    

  },
  {
    show: false,
    id: '14',
    project: "Project 14",
    github: "https://github.com/pranitcode/Project-14-UI",
    demo: "https://project-14-ui.netlify.app/",
    about: "",
    Image: require("../../img/proj14.png").default
    
    

  },
  {
    show: true,
    id: '15',
    project: "Project 15",
    github: "https://github.com/pranitcode/Project-15-UI",
    demo: "https://project-15-ui.netlify.app/",
    Image: require("../../img/proj15.png").default
    
    

  
  },
  ];
